import { FormattedMessage, injectIntl } from 'react-intl';
import React, { useContext, useEffect } from 'react';
import { Statistic, Modal } from 'antd';
const { warning } = Modal;
import myContext from '@/utils/createContext';
import { getUrlParams } from '@/utils/index.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Countdown } = Statistic;

const key = getUrlParams('key'); // 从 URL 中获取 key
function Header(props) {
  const intl = props.intl;
  // const data = useContext(myContext);
  const { resData } = useContext(myContext);
  let ttl = resData.ttl;
  // 如果后端不传ttl，或者传了其他的值，像null，undefined，0，都置成0
  if (!ttl || ttl < 0) {
    ttl = 0;
  }

  const deadline = Date.now() + ttl * 1000;

  function onFinish() {
    // 提示用户订单失效，跳转到商户页面重新发起创单
    const { cancelUrl } = resData;
    warning({
      centered: true,
      // content: 'The order has timed out, please re-initiate payment',
      content: intl.formatMessage({
        id: 'ga-checkout.order-time-out',
      }),
      // okText: 'Got It',
      okText: intl.formatMessage({ id: 'ga-checkout.got-it' }),
      icon: <ExclamationCircleOutlined />,
      onOk() {
        return new Promise((resolve, reject) => {
          if (cancelUrl) {
            window.location.href = cancelUrl;
          } else {
            // 由于首页后端接口调整，取消此跳转逻辑
            // window.location.href = `/?key=${key}`;
            window.location.reload();
          }
        }).catch(() => console.log('error!'));
      },
    });
  }

  return (
    <div>
      <header className="header">
        {/* logo */}
        {/* <div className="header-logo">
        <img src="/static/images/LianLianGlobal@2x.png" alt="logo" />
      </div> */}

        {/* 支付倒计时 */}
        <div className="header-countdown">
          <span className="header-countdown-icon bg-shijian"></span>
          {deadline && (
            <Countdown
              className="header-countdown-time"
              value={deadline}
              onFinish={onFinish}
              valueStyle={{ fontSize: '18px' }}
            />
          )}
          <span className="header-countdown-text">
            <FormattedMessage id="ga-checkout.required-time-tips" />
            {/*Please complete payment within the required time, otherwise your order*/}
            {/*will be cancelled.*/}
          </span>
        </div>
      </header>
    </div>
  );
}

export default injectIntl(Header);
